<template>
  <div class="pageWuadetail">
    <XR-head titleText="交易明细" :rightShow="false"></XR-head>
    <div class="detail-traceAmt" v-if="!loaded">
        <span class="amt">{{wuaStream.Operater+wuaStream.TraceAmt}}</span>
    </div>
    <div class="row-list" v-if="!loaded">        
      <div class="row-item">
          <p class="item-title">发款方</p>
          <p class="item-value">{{wuaStream.ExpensesAddress}}</p>
      </div>
              
      <div class="row-item">
          <p class="item-title">收款方</p>
          <p class="item-value">{{wuaStream.IncomeAddress}}</p>
      </div>
      <div class="row-item">
          <p class="item-title">交易类型</p>
          <p class="item-value">{{wuaStream.TraceTypeName}}</p>
      </div>
      <div class="row-item">
          <p class="item-title">备注</p>
          <p class="item-value">{{wuaStream.Desc}}</p>
      </div>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data() {
    return {
        loaded:true,
        wuaStream:{}
    };
  },
  mounted :function(){
    this.$refs.XRtoast.load()
    
    if(!this.$route.query.traceNo){
        return
    }
    this.getWuaStream()
  },
  methods: {
      getWuaStream: function() {
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetWuaStream",
        JSON.stringify({traceNo:this.$route.query.traceNo})
      ).then(function(res) {
        if(!res.IsSuccess){
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.wuaStream = res.Data;
          ths.loaded = false
          ths.$refs.XRtoast.hide()
        }
      });
    }
  }
};
</script>
<style>
*{
  margin: 0;
  padding: 0;
}
#app .pageWuadetail{
    background: white;
}
.pageWuadetail .detail-traceAmt {
    overflow:hidden;
    text-align:center;
    margin: 0 20px;
    border-bottom:1px solid #efefef;
    padding:35px 0 35px;
}
    .pageWuadetail .detail-traceAmt .amt {
        font-size:30px;
    }
    .pageWuadetail .detail-traceAmt .unit {
        font-size:12px;
        color:#aaa;
    }
.pageWuadetail .row-list {
    margin: 0 20px;
    padding:30px 0;
}
   .pageWuadetail  .row-list .row-item {
        padding:10px 0;
    }
      .pageWuadetail   .row-list .row-item .item-title {
            color:#ccc;
            font-size:16px;
        }
       .pageWuadetail  .row-list .row-item .item-value {
            font-size:12px;
            padding-top:2px;
            word-break: break-all;
        }
    .pageWuadetail .row-list.last {
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/wuaDetail.vue